module.exports = __webpack_public_path__ + "media/images/___novum-logo-animated-long-d1c61bfba091d11eeb13837a26a0ff94.svg";